import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase/config";

const Login = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [showResetForm, setShowResetForm] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        credentials.email,
        credentials.password
      );

      const userDoc = await getDoc(doc(db, "users", userCredential.user.uid));
      const userData = userDoc.data();

      if (userData?.isAdmin) {
        navigate("/admin/dashboard");
      } else {
        navigate("/");
      }
    } catch (error) {
      setError("Invalid credentials");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSent(true);
      setTimeout(() => {
        setShowResetForm(false);
        setResetSent(false);
      }, 3000);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[80vh]">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        {showResetForm ? (
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
              Reset Password
            </h2>
            {resetSent && (
              <div className="p-2 mb-4 text-sm text-green-600 bg-green-50 rounded text-center">
                Password reset email sent!
              </div>
            )}
            {error && (
              <div className="p-2 mb-4 text-sm text-red-600 bg-red-50 rounded text-center">
                {error}
              </div>
            )}
            <form onSubmit={handleForgotPassword} className="space-y-4">
              <input
                type="email"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                placeholder="Enter your email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
              <button
                type="submit"
                className="w-full py-2 px-4 text-white bg-blue-600 hover:bg-blue-700 rounded-md transition duration-200"
              >
                Send Reset Link
              </button>
              <button
                type="button"
                onClick={() => setShowResetForm(false)}
                className="w-full py-2 px-4 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition duration-200"
              >
                Back to Login
              </button>
            </form>
          </div>
        ) : (
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">Login</h2>
            {error && (
              <div className="p-2 mb-4 text-sm text-red-600 bg-red-50 rounded text-center">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                placeholder="Email"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
              />
              <input
                type="password"
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                placeholder="Password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              />
              <button
                type="submit"
                className="w-full py-2 px-4 text-white bg-blue-600 hover:bg-blue-700 rounded-md transition duration-200"
              >
                Sign in
              </button>
            </form>
            <div className="mt-4 text-center">
              <button
                onClick={() => setShowResetForm(true)}
                className="text-blue-600 hover:text-blue-800"
              >
                Forgot Password?
              </button>
            </div>
            <div className="mt-4 text-center">
              <p className="text-gray-600">
                Don't have an account?{" "}
                <Link to="/signup" className="text-blue-600 hover:text-blue-800">
                  Sign up
                </Link>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
